import { Routes } from "@angular/router";

export const PRIVACY_POLICY_ROUTES: Routes = [
  {
    path: "",
    loadComponent: () =>
      import("./pages/privacy-policy/privacy-policy.component").then(
        (m) => m.PrivacyPolicyComponent,
      ),
  },
];
